import React, {
  createContext,
  useContext,
} from "react";
import PropTypes from "prop-types";

import {
  assertStudioRuntime,
} from "../../engines/StudioPluginEngine";

const StudioRuntimeContext = createContext(null);

export function StudioRuntimeProvider({
  runtime,
  children,
}) {
  const validatedRuntime = assertStudioRuntime(runtime);

  return (
    <StudioRuntimeContext.Provider value={validatedRuntime}>
      {children}
    </StudioRuntimeContext.Provider>
  );
}

StudioRuntimeProvider.propTypes = {
  runtime: PropTypes.shape({
    registerPlugin: PropTypes.func.isRequired,
    unregisterPlugin: PropTypes.func.isRequired,
    resolveCapabilities: PropTypes.func.isRequired,
    resolveContributions: PropTypes.func.isRequired,
  }).isRequired,
  children: PropTypes.node,
};

export function useStudioRuntime() {
  const runtime = useContext(StudioRuntimeContext);

  if (!runtime) {
    throw new Error(
      "useStudioRuntime must be used inside StudioRuntimeProvider."
    );
  }

  return runtime;
}

export default StudioRuntimeContext;
